export const SEARCH_PARAM_KEY = 'timeFilter';
export const DATA_GA_EVENT = 'prematch-time-filter-change';

export const TEMPLATE = {
  0: 'minuteShort',
  1: 'hourShort',
  2: 'dayShort',
};

export const timeFilterTabItemAll =   {
  id: 'all',
  label: 'Все',
  to: `?${SEARCH_PARAM_KEY}=all`,
  dataGaValues: {
    ['data-ga-event']: `${DATA_GA_EVENT}-all`,
    ['data-ga-event-value']: 'all',
  },
};
